export const addSubscriberToKlaviyo = async (email, name) => {
    console.log('Adding subscriber to Klaviyo:', email, name);
  try {
    const response = await fetch('/api/klaviyo-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, name })
    }
);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error('Failed to add subscriber to Klaviyo: ' + errorText);
    }
    return true;
  } catch (error) {
    console.error('Klaviyo integration error:', error);
    return false;
  }
};

export const addFirstProjectCreatorToList = async (email,name) => {
  if (!email) {
    console.error('Invalid email for Klaviyo');
    return false;
  }
  try {
    const response = await fetch('/api/klaviyo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, name })

    });
    
    if (!response.ok) {
      throw new Error('Failed to add to first project creators list');
    }
    return true;
  } catch (error) {
    console.error('Failed to add to first project creators list:', error);
    return false;
  }
};
